import { styled } from '@material-ui/core';

import { Box } from '@backstage/ui';

export const FloatingCard = styled(Box)({
  background: 'var(--bui-bg-surface-1)',
  border: '1px solid var(--bui-border)',
  borderRadius: 6,
  overflow: 'hidden',
  '&:hover': {
    borderColor: 'var(--bui-border-hover)',
  },
  '&:focus, &:focus-within, &:active': {
    borderColor: 'var(--bui-border-pressed)',
  },
  boxShadow: '0 1px 2px rgba(0,0,0,0.04), 0 4px 12px rgba(0,0,0,0.08)',
});

export const ToolbarCard = styled(FloatingCard)({
  overflow: 'visible',
});
